<template lang="pug">
  main.app-main
    chart-box
    exchange
    orderbook
</template>

<script>
  import ChartBox from './Main/ChartBox.vue'
  import Exchange from './Main/Exchange.vue'
  import Orderbook from './Main/Orderbook.vue'

  export default {
    components: {
      ChartBox,
      Exchange,
      Orderbook
    }
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/variables.sass"

  main
    display: grid
    grid-template-columns: repeat(3, calc(100% / 3))
    grid-template-rows: auto auto

  .chart-box
    grid-column: 1 / span 2

  .exchange
    grid-column: 3

  .orderbook
    grid-column: 1 / span 3
</style>
